import { app } from '../../bootstrap/core';
import { notFoundState } from './notFound.state';
import { notFoundComponent } from './notFound.component';

angular.module(app.name)
  .config(notFoundState)
  .component(notFoundComponent.name, notFoundComponent);
